import React from "react";
import styles from "./styles/ChannelPartnerHero.module.css";
import heroBg from "../../../images/hero.jpg";
import mitsubishiLogo from "../../../images/Mitsubishi-Logo_CP.png";

export default function ChannelPartnerHero() {
  return (
    <section className={styles.hero} style={{ backgroundImage: `url(${heroBg})` }}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>Authorised Channel Partner for Mitsubishi Electric FA</h1>
          <p className={styles.description}>offering worldclass factory automation products</p>
          <div className={styles.logo}>
            <img
              src={mitsubishiLogo}
              alt="Mitsubishi Electric Factory Automation Channel Partner"
              className={styles.logoImg}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
